var _rect, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.603378,
    y: 0.478378,
    width: 58.0432,
    height: 58.0432,
    stroke: "#C71A33",
    strokeWidth: 0.956757
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3762 20.7743L19.6573 27.6425C18.9443 27.9623 18.7031 28.6028 19.485 28.9504L24.0306 30.4025L35.0215 23.5748C35.6216 23.1462 36.236 23.2605 35.7073 23.732L26.2677 32.3232L25.9711 35.9589C26.2458 36.5203 26.7487 36.5229 27.0694 36.2439L29.6811 33.7599L34.1539 37.1266C35.1927 37.7448 35.758 37.3458 35.9815 36.2128L38.9153 22.2492C39.2199 20.8545 38.7004 20.24 37.3762 20.7743Z",
    fill: "#FF2242"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_416_1198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.3762 20.7743L19.6573 27.6425C18.9443 27.9623 18.7031 28.6028 19.485 28.9504L24.0306 30.4025L35.0215 23.5748C35.6216 23.1462 36.236 23.2605 35.7073 23.732L26.2677 32.3232L25.9711 35.9589C26.2458 36.5203 26.7487 36.5229 27.0694 36.2439L29.6811 33.7599L34.1539 37.1266C35.1927 37.7448 35.758 37.3458 35.9815 36.2128L38.9153 22.2492C39.2199 20.8545 38.7004 20.24 37.3762 20.7743Z",
    fill: "#FF2242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_416_1198",
    x: 5,
    y: 5,
    width: 48,
    height: 47.9999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_416_1198"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.df2e72bd0c121f2863420453c7456ec9.svg";
export { ForwardRef as ReactComponent };